import { render, staticRenderFns } from "./bookCon.vue?vue&type=template&id=54e63dcc&scoped=true&"
import script from "./bookCon.vue?vue&type=script&lang=js&"
export * from "./bookCon.vue?vue&type=script&lang=js&"
import style0 from "./bookCon.vue?vue&type=style&index=0&id=54e63dcc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e63dcc",
  null
  
)

export default component.exports